import * as React from 'react'
import { FC, useCallback } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { BulkReopenForm } from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { BulkReopenInput } from '@user/components/xGrid/atoms/BulkActions/typings/BulkReopen'
import { bulkReopenOpps } from '@user/store/opportunity'
import { useData } from '@user/components/Opportunities/OpportinutyListView/OpportunityBulkActions/Sidebars/hooks/useData'

export const BulkReopenOpps: FC = () => {
  const dispatch = useAppDispatch()
  const { status } = useData()
  const validateRows = useCallback(
    async (model: BulkReopenInput) => {
      const response = await dispatch(bulkReopenOpps({ model }))
      if (bulkReopenOpps.fulfilled.match(response)) {
        return response.payload.model
      }
    },
    [dispatch],
  )

  const onSubmit = useCallback(
    async (model: BulkReopenInput) =>
      void (await dispatch(
        bulkReopenOpps({
          model,
          mode: 'commit',
        }),
      )),
    [dispatch],
  )

  return (
    status === 'success' && (
      <BulkReopenForm
        entityType={ENTITY_TYPES.Opportunity}
        validateRows={validateRows}
        onSubmit={onSubmit}
      />
    )
  )
}
BulkReopenOpps.displayName = 'BulkReopenOpps'
